module.exports = __webpack_public_path__ + "img/per04.ba79300d.png";